import { ISkillLevelResource } from "../../skill-levels";
import { IHydraList } from "../../types";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillLevelTranslationResource } from "../types";

export type ISkillLevelTranslationsQueryParameters = {
    /** Left out to read nothing, which is what a level the api cannot address by uuid answers. */
    skillLevel?: RelationalValue<ISkillLevelResource>;
};

export type ISkillLevelTranslationsQueryResult = IHydraList<ISkillLevelTranslationResource>;

export const skillLevelTranslationsQuery: IApiQueryFunction<ISkillLevelTranslationsQueryParameters> = ({
    skillLevel,
}) => {
    if (!skillLevel) {
        return;
    }

    return {
        method: "GET",
        url: `/skill_levels/${mapRelationalValue(skillLevel)}/translations`,
    };
};

export const useSkillLevelTranslationsQuery = createApiQueryHook<
    ISkillLevelTranslationsQueryParameters,
    ISkillLevelTranslationsQueryResult
>(skillLevelTranslationsQuery);
